var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 208.695,
    viewBox: "0 0 300 208.695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Laptop_Simple",
    "data-name": "Laptop Simple",
    d: "M49.914,9A22.978,22.978,0,0,0,27.088,31.826V155.738a22.978,22.978,0,0,0,22.826,22.826H252.086a22.978,22.978,0,0,0,22.826-22.826V31.826A22.978,22.978,0,0,0,252.086,9Zm0,19.565H252.086a3.115,3.115,0,0,1,3.261,3.261V155.738A3.115,3.115,0,0,1,252.086,159H49.914a3.115,3.115,0,0,1-3.261-3.261V31.826A3.115,3.115,0,0,1,49.914,28.565ZM10.783,198.129a9.783,9.783,0,1,0,0,19.566H291.216a9.783,9.783,0,1,0,0-19.566Z",
    transform: "translate(-1 -9)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.404ef2b5379df225258523b8611a1b2a.svg";
export { ForwardRef as ReactComponent };